export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover"},{"name":"description","content":"국내 1위 보장균수 4,500억 프리미엄 프로바이오틱스 드시모네. 첫 구매 할인, 추가 적립금, 경품 이벤트까지 공식몰만의 특별한 혜택을 만나보세요"},{"property":"og:type","content":"website"},{"property":"og:title","content":"드시모네몰 | 공식몰"},{"property":"og:description","content":"국내 1위 보장균수 4,500억 프리미엄 프로바이오틱스 드시모네. 첫 구매 할인, 추가 적립금, 경품 이벤트까지 공식몰만의 특별한 혜택을 만나보세요"},{"property":"og:url","content":"https://www.desimone.co.kr/"},{"name":"author","content":"드시모네"}],"link":[{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100..900&display=swap"}],"style":[],"script":[],"noscript":[],"title":"드시모네몰 | 공식몰"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false